import { PageBlockTypes as p } from '@xprog/prensa/types'

export const Template100: p.PageBlockProps = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none',
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle'],
        },
        '.ColumnTop .Item': {
          // width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        },
      },
      '@xl': {
        px: '$0',
      }
    },
  }
}